module.exports = __webpack_public_path__ + "img/2.6651bfda.png";